<app-phx-select-box [items]="items" [value]="value" [readOnly]="readOnly" [disabled]="disabled"
    [searchable]="searchable" [showClearButton]="showClearButton" [placeholder]="placeholder"
    [itemTemplateRef]="itemTemplateRef" [itemTemplate]="itemTemplate" [valueField]="valueFieldName"
    [textField]="textFieldName" (valueChanged)="onValueChanged($event)">
</app-phx-select-box>